import React, { useEffect, useState } from 'react';
import TimeRangeSelector from '../components/TimeRangeSelector';

function DeviceLogs() {
  const [units, setUnits] = useState([]);
  const [unit, setUnit] = useState('');
  const [range, setRange] = useState('Live');
  const [rows, setRows] = useState([]);
  const user =
    localStorage.getItem('username') ||
    sessionStorage.getItem('username') ||
    'demo';

  useEffect(() => {
    fetch(`/get_units.php?username=${encodeURIComponent(user)}`)
      .then((res) => res.json())
      .then((d) => setUnits(d))
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    if (units.length && !unit) {
      setUnit(units[0]);
    }
  }, [units]);

  useEffect(() => {
    if (!unit) return;
    fetch(
      `/get_unit_data.php?table=${encodeURIComponent(unit)}&range=${encodeURIComponent(
        range
      )}&full=1&username=${encodeURIComponent(user)}`
    )
      .then((res) => res.json())
      .then((d) => setRows(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, [unit, range, user]);

  const columns = rows[0] ? Object.keys(rows[0]) : [];

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-center gap-2 mb-4">
        <h1 className="text-2xl font-bold mr-auto">Device Logs</h1>
        <TimeRangeSelector
          units={units}
          onRangeChange={setRange}
          onUnitChange={setUnit}
          selectedUnit={unit}
          groupId="table-range"
        />
      </div>
      <div className="bg-[#12151C] rounded-lg overflow-auto scrollbar">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left border-b border-[#3D3D3D]">
              {columns.map((col) => (
                <th key={col} className="p-2 capitalize">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} className="border-b border-[#3D3D3D]">
                {columns.map((col) => (
                  <td key={col} className="p-2 whitespace-nowrap">
                    {row[col]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DeviceLogs;
